import {
  ActionIcon,
  Badge,
  Box,
  Group,
  Menu,
  Switch,
  Text,
  rem,
  useMantineColorScheme,
  useMantineTheme,
} from '@mantine/core';
import { IconHome, IconMenu, IconMoon, IconSun } from '@tabler/icons-react';
import classes from './NavBar.module.css';

export function NavBarSimple({ presentation }) {
  const { colorScheme, setColorScheme } = useMantineColorScheme();
  const theme = useMantineTheme();

  return (
    <Box>
      <header className={classes.header}>
        <Group justify="space-between" h="100%" gap="0">
          <Group>
            <ActionIcon
              component="a"
              href="/presentations"
              size={42}
              variant="default"
              aria-label="ActionIcon with size as a number"
              style={{ border: 0 }}
            >
              <IconHome style={{ width: rem(24), height: rem(24) }} />
            </ActionIcon>
            <Group gap="0">
              <Text truncate="end" w={{ base: 120, sm: 'auto' }}>
                {presentation?.title}
              </Text>
            </Group>
            {presentation?.status === 'preparing' && (
              <Badge component="span" color="orange">
                Preparing
              </Badge>
            )}
            {presentation?.status === 'failed' && (
              <Badge component="span" color="red">
                Failed
              </Badge>
            )}
          </Group>

          <Group hiddenFrom="sm">
            <Menu shadow="md">
              <Menu.Target>
                <ActionIcon size="lg" variant="subtle" aria-label="Menu">
                  <IconMenu style={{ width: '70%', height: '70%' }} stroke={1.5} />
                </ActionIcon>
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Item>
                  <Switch
                    checked={colorScheme === 'light'}
                    onChange={(event) =>
                      setColorScheme(event.currentTarget.checked ? 'light' : 'dark')
                    }
                    size="md"
                    onLabel={
                      <IconSun
                        style={{ width: rem(16), height: rem(16) }}
                        stroke={2.5}
                        color={theme.colors.yellow[4]}
                      />
                    }
                    offLabel={
                      <IconMoon
                        style={{ width: rem(16), height: rem(16) }}
                        stroke={2.5}
                        color={theme.colors.blue[6]}
                      />
                    }
                  />
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          </Group>

          <Group h="100%" gap={0} visibleFrom="sm">
            <Switch
              checked={colorScheme === 'light'}
              onChange={(event) => setColorScheme(event.currentTarget.checked ? 'light' : 'dark')}
              size="lg"
              mr="md"
              onLabel={
                <IconSun
                  style={{ width: rem(16), height: rem(16) }}
                  stroke={2.5}
                  color={theme.colors.yellow[4]}
                />
              }
              offLabel={
                <IconMoon
                  style={{ width: rem(16), height: rem(16) }}
                  stroke={2.5}
                  color={theme.colors.blue[6]}
                />
              }
            />
          </Group>
        </Group>
      </header>
    </Box>
  );
}
